import { GetServerSideProps } from "next";
import { getStringQueryParam } from "src/services/UrlService";
import AffiliateOffersPage, { AffiliatePageProps, getAffiliateServerSideProps } from "src/shared/affiliate";

export default AffiliateOffersPage;
export const getServerSideProps: GetServerSideProps<AffiliatePageProps> = async ({ req }) => {
  return getAffiliateServerSideProps(getStringQueryParam(req?.headers["x-vercel-ip-country-region"]), "sportsbook");
};
